import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function SeoMeta({
  title = 'ENTREPRENØR LANG ApS | Aut. kloakmester & entreprenør',
  description = 'aut kloakmester',
  keywords = 'kloak, gravearbejde, snerydning, glatførebekæmpelse, vandværksservice, belægning, Øster Ulslev',
  ogImage = 'https://assets.auxodev.dk/assets/7d468145-c8f2-4ea0-936d-cc188f08bb8a/hero-entreprenor-gravemaskine.jpg',
  canonicalUrl,
}) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
    </Helmet>
  );
}
